// extracted by mini-css-extract-plugin
module.exports = {"container":"ImgBox_style_container__1Os1a","item":"ImgBox_style_item__1AzhY"};